module.exports = __webpack_public_path__ + "img/icon-bloodsugar-inactive.090f921a.png";